import Vue from 'vue'
import service from '../services/bankAccountsService'

export function useBankAccounts() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getBankAccounts(params = {}) {
    state.loading = true
    try {
      const response = await service.getBankAccounts(params)
      state.items = response.accounts.current_page == '1'
        ? [...response.accounts.data]
        : [...state.items, ...response.accounts.data]
      state.currentPage = response.accounts.current_page
      state.lastPage = response.accounts.last_page
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getBankAccounts }
}
